
import { defineComponent } from "vue";
import { useRouter } from "vue-router";
import { searchProduct } from "@/api/shopApi";

export default defineComponent({
    setup() {
        const router = useRouter();
        return {
            router, //一定要要放在return里才能在模板上面使用
        };
    },
    name: "PageSearch",
    // components: { Empty },
    props: {},
    mounted() {
        this.loadData();
    },
    methods: {
        itemClick(str) {
            this.value = str;
            this.onSearch();
        },
        getSearchHistoryData() {
            const jsonStrData = localStorage["searchHistory"];
            if (!jsonStrData) {
                return [];
            }
            try {
                const data = JSON.parse(localStorage["searchHistory"]);
                return data;
            } catch (error) {
                return [];
            }
        },
        async loadData() {
            this.data = this.getSearchHistoryData();
            if (this.data.length > 0) {
                await this.$nextTick();
                const wrapHeight =
                    this.$refs.historyWrap.getBoundingClientRect().height;
                const innerHeight = this.$refs.historyWrap
                    .getElementsByClassName("history-inner")[0]
                    .getBoundingClientRect().height;
                if (wrapHeight < innerHeight) {
                    this.showExpanded = true;
                }
            }
            this.loading = false;
            this.LoadTag();
        },
        async LoadTag() {
            let list = await searchProduct("", 1, 8);
            this.tagList = list.rows;
        },
        itemClickTag(item) {
            const id = item.id;
            sessionStorage.setItem("type", JSON.stringify(0));
            this.router.push(`/shop/goods/detail/${id}`);
        },
        onCancel() {
            this.router.go(-1);
        },
        onSearch() {
            // 没有输入，不搜索
            if (!this.value) return;
            this.storageData();
            this.router.replace(
                "/shop/page/searchresult/" + encodeURIComponent(this.value)
            );
            this.value = "";
        },
        storageData() {
            // let exists = false;
            for (let index = 0; index < this.data.length; index++) {
                const element = this.data[index];
                if (element == this.value) {
                    // 删除存在的数据
                    // exists = true;
                    this.data.splice(index, 1);
                    break;
                }
            }
            // if (exists) {
            //     this.data.splice(0, 0, this.value);
            // }
            // 添加进来
            this.data.splice(0, 0, this.value);
            // 去除超出的数量
            this.data.splice(9, 10);
            localStorage["searchHistory"] = JSON.stringify(this.data);
        },
        del() {
            this.$dialog
                .confirm({
                    title: "提示",
                    message: "确认要清除历史记录吗",
                })
                .then(() => {
                    this.data = [];
                    localStorage["searchHistory"] = JSON.stringify(this.data);
                })
                .catch(() => {
                    // on cancel
                });
        },
    },
    data() {
        return {
            value: "",
            data: [],
            tagList: [],
            isToggle: false,
            loading: true,
            // 是否显示展开按钮
            showExpanded: false,
        };
    },
});
